/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchGlobalSetting, saveGlobalSetting } from "../action/common";
import GeneralIcon from "../../pages/Settings/GeneralIcon";
import {
    BtnBold,
    BtnBulletList,
    BtnClearFormatting,
    BtnItalic,
    BtnNumberedList,
    BtnRedo,
    BtnStrikeThrough,
    BtnStyles,
    BtnUnderline,
    BtnUndo,
    HtmlButton,
    Separator,
    Editor,
    EditorProvider,
    createButton,
    Toolbar} from 'react-simple-wysiwyg';
import { InsertLinkIcon } from "../LandingHeader/Feedback/icons/Icons";
import FeatureUpdateModal from "../../pages/Settings/Modal/FeatureUpdateModal";

const BtnLink = createButton(
    "Link",
    <InsertLinkIcon />,
    ({ $selection }) => {
        if ($selection?.nodeName === "A") {
        document.execCommand("unlink");
        } else {
        const Selection = document.getSelection()?.toString();
        // eslint-disable-next-line no-alert -- ignore
        const Uri = prompt("URL", "");
        document.execCommand(
            "insertHTML",
            false,
            Uri ? `<a href="${Uri}" target="_blank" title="${Uri}">${Selection ? Selection : Uri}</a>` : Selection,
        );
        }
    },
);

function NotificationSettings({ activeTab, setActiveTab }) {
    const { theme, colorPicker, colorPickerDark } = useSelector(state => state.theme);
    const [settings, setSettings] = useState({});
    const [saving, setSaving] = useState(false);
    const [preview, setPreview] = useState(false);

    const getSettings = async () => {
        try{
            const response = await fetchGlobalSetting();
            let settings = {}
            if(response?.data?.responseData) {
                response?.data?.responseData.map((item) => {
                    settings = { ...settings, [item?.settingName]: item?.settingValue };
                });

                setSettings(settings);
            }
        } catch(e) {}
    }

    const handleChange = (value, name) => {
        setSettings((prev) => ({ ...prev, [name]: value }));
        setSaving(false)
    }

    const saveSettings = async (e) => {
        e.preventDefault();
        setSaving(true)
        try{
            const response = await saveGlobalSetting({settings});
            if(response?.data?.responseData) {
                setSaving(null)
            }
        } catch(e) {
            console.log(e)
            setSaving(false)
        }
    }

    useEffect(() => {
        getSettings();
    }, []);

    const showPreview = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setPreview(true)
    }

    return (
        <>
            <li
            css={{
                '&:hover .accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important") : "white !important"
                },
                '.accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c") && (activeTab == "notification")) ? "white !important" : ((theme == "dark" && colorPickerDark == "#f8961e") && (activeTab == "notification")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#ffca3a") && (activeTab == "notification")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#27cb9a") && (activeTab == "general")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#4cc9f0") && (activeTab == "notification")) ? "black !important" : "white !important") : "white"
                },
                '.rsw-ce':{
                    a: {
                        color: `var(--accent-color) !important`
                    }
                }
            }}
            className={`li-setting-tab ${activeTab == "notification" ? 'active' : ''}`}>
                <div className="settings-accordion-tab"
                    onClick={() => { setActiveTab(activeTab => activeTab == 'notification' ? null : 'notification'); }}
                    style={{ background: theme == "dark" ? "black" : "" }}
                    css={{
                    background: activeTab == 'notification' ? `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important` :
                        '',
                    '&:hover': {
                        background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important`,
                    }
                    }}>
                    <div className="settings-accordion-heading">
                    <figure className="settings-icon">
                        <img src="/images/general.svg" className="img-default dark:invert-color" />
                    </figure>
                    <h3 className="accordion-title uppercase dark:text-white">Notification</h3>
                    </div>
                    <div className="settings-accordion-arrow">
                        <img src="/images/arrow-down.svg" className="dark:invert-color" />
                    </div>
                </div>
                {
                    activeTab == 'notification' 
                    && 
                    <div className="settings-accordion-content">
                        <div className="inner-form" style={{ background: theme == "dark" ? "black" : "" }}>
                            <h3>Notification Settings</h3>
                            <div className="field-block mt-[30px]">
                                <label className="field-label dark:text-white dark:opacity-70">Notification Text</label>    
                                <div className="field-data">
                                    <EditorProvider>
                                        <Editor value={settings?.newFeatureText ?? ''} onChange={e => handleChange(e.target.value, 'newFeatureText')}>
                                            <Toolbar>
                                                <BtnUndo />
                                                <BtnRedo />
                                                <Separator />
                                                <BtnBold />
                                                <BtnItalic />
                                                <BtnUnderline />
                                                <BtnStrikeThrough />
                                                <Separator />
                                                <BtnNumberedList />
                                                <BtnBulletList />
                                                <Separator />
                                                <BtnLink />
                                                <BtnClearFormatting />
                                                <HtmlButton />
                                                <Separator />
                                                <BtnStyles />
                                            </Toolbar>
                                        </Editor>
                                    </EditorProvider>
                                </div>
                            </div>
                            <div className="field-block mt-[60px]">
                                <label className="field-label dark:text-white dark:opacity-70">App Version</label>
                                <div className="field-data">
                                    <input defaultValue={settings?.newFeatureVersion ?? ''} type="text" className="input-field" placeholder="Enter your App Version" onInput={e => handleChange(e.target.value, 'newFeatureVersion')} />
                                </div>
                            </div>
                            <div className="field-block mt-[60px]">
                                <button className="changeName mt-5"
                                css={{
                                    background: theme == "dark" ? `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000 !important` : `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), #ffffff !important`,
                                    color: `var(--accent-color) !important`
                                            
                                }}
                                onClick={saveSettings}>{saving === true ? 'Saving...' : (saving === false ? 'Save Settings' : 'Saved')}</button>
                                <button className="changeName mt-5 ml-5" 
                                onClick={showPreview}
                                css={{
                                    background: theme == "dark" ? `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000 !important` : `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), #ffffff !important`,
                                    color: `var(--accent-color) !important`
                                }}
                                >Preview</button>
                            </div>
                        </div>
                    </div>
                }
            </li>
            {preview && <FeatureUpdateModal preview={settings?.newFeatureText ?? ''} setPreview={setPreview} /> }
        </>
    );
}

export default NotificationSettings;